<div class="container-fluid">
    <div class="row dark py-2">
        <div class="col-md-12 header-center">
            <h3>ABILITY AND SKILLS</h3>
            <div>
                <p class="separator"> </p>
            </div>
        </div>
    </div>

    <div class="row dark text-white">
        <div class="col-md-6 my-2 b-2-white">
            <h4 class="text-center">Concepts</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.concepts">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Server Side</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.serverSide">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Build Tools</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.buildTools">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Unit testing</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.unitTesting">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Cloud</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.cloud">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>
            <!--Add Skills above this line-->
        </div>

        <!--box2-->
        <div class="col-md-6 my-2">
            <h4 class="text-center">Programming Languages</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.programmingLanguages">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Web</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.web">
                <div class="col-md-3"> {{skill.name}} </div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Database Management Systems</h4>
            <h5 class="text-center">RDBMS</h5>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.rdbms">
                <div class="col-md-3">{{skill.name}}</div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h5 class="text-center">NoSQL</h5>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.nosql">
                <div class="col-md-3">{{skill.name}}</div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">Version Control System</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.versionControlSystem">
                <div class="col-md-3">{{skill.name}}</div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>
            <h4 class="text-center">Containers</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.containers">
                <div class="col-md-3">{{skill.name}}</div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="text-center">IDE</h4>
            <div class="row skills-50 my-2" *ngFor="let skill of skills.ide">
                <div class="col-md-3">{{skill.name}}</div>
                <div class="col-md-3">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                            [style.width]="skill.percentValue" [attr.aria-valuenow]="skill.value" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>

            <!--Add skills above this line-->
        </div>
    </div>
</div>